export default __webpack_public_path__ + "static/media/background-photo.d9fb048d.jpg";